import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/header';
import Navigation from '../components/navigation';
import NavigationContext from '../contexts/navigation-context';
import config from '../config';

export default function AppLayout(props) {
  const {children} = props;
  const {open, setOpen, applications} = React.useContext(NavigationContext);
  const onRequestOpen = React.useCallback(() => setOpen(true));

  return (
    <div>
      <Header />
      <div data-region="navigation">
        <Navigation
          applications={applications}
          open={open}
          onRequestOpen={onRequestOpen}
          launchpadConfig={config.launchpad}
        />
      </div>
      <div className={`scrollable-content ${open ? 'nav-open' : ''}`}>{children}</div>
    </div>
  );
}

AppLayout.propTypes = {
  /** The component to render in the main content area. */
  children: PropTypes.node.isRequired,
};
